/**
 * Utility functions for catalog manager
 */

/**
 * Generates an image URL for an item or section based on its ID
 * @param id The ID of the item or section
 * @returns The image URL
 */
export function getImageUrl(id: string | number): string {
  return `https://b2c-a872.kxcdn.com/apps/tuner/images/${id}_main.webp.thumbnail`;
}
